import { Avatar } from 'antd';
import { resolveCollectionFileUrl } from '../../api/collectionFiles';

/**
 * @param {{ user: object | null | undefined }} args
 * @returns {string | undefined} Image URL, or undefined if none.
 */
export function getUserAvatarSrc(user) {
  if (!user?.id) return undefined;
  const collectionKey = user.collectionName || user.collectionId;
  if (!collectionKey || !user.avatar?.trim()) return undefined;
  const url = resolveCollectionFileUrl({
    collectionName: collectionKey,
    recordId: user.id,
    fileName: user.avatar,
  });
  return url || undefined;
}

/**
 * Avatar for staff user record (PocketBase file field or absolute URL).
 */
export default function UserAvatar({ user, size = 40, className, ...rest }) {
  const src = getUserAvatarSrc(user);
  const label = (user?.name?.trim() || user?.email || '?').slice(0, 1).toUpperCase();

  const alt = user?.name ? `${user.name} avatar` : 'User avatar';

  return (
    <Avatar src={src} size={size} className={className} alt={alt} {...rest}>
      {label}
    </Avatar>
  );
}
